import React from 'react';
import { useAppNavigation } from '../../hooks/useAppNavigation';
import { useQueryClient } from '@tanstack/react-query';
import UserProfile from './components/UserProfile';
import { UserEvents } from '../../lib/analytics';
import { getOnboardingData, confirmAndLinkFamily } from '../../lib/onboardingSession';

export const UserProfilePage: React.FC = () => {
  const { goHome, goBack } = useAppNavigation();
  const queryClient = useQueryClient();

  const handleComplete = async () => {
    // 初回登録フロー（オンボーディング中）の場合、家族連携を確定する
    const onboardingData = getOnboardingData();
    // 新規連携した patient_id を保持し、ホーム遷移時に着地先として指定する
    // （2人目以降の登録時にホームが既存利用者へ着地するのを防ぐ）
    let linkedPatientId: number | undefined;
    if (onboardingData) {
      try {
        linkedPatientId = await confirmAndLinkFamily(queryClient);
      } catch (err) {
        // 家族連携失敗してもプロフィール保存は成功しているため、後続処理は継続する
        console.error('家族連携に失敗しました:', err);
      }
    }

    // 1. キャッシュを即座に更新（UIの即応性）
    queryClient.setQueryData(['userProfile', 'check'], { completed: true });

    // 2. バックグラウンドで再検証（データ整合性）
    await queryClient.invalidateQueries({
      queryKey: ['userProfile', 'check'],
      refetchType: 'active'
    });

    // Analytics: プロフィール完了イベント
    UserEvents.profileCompleted();

    // 3. 完了後にホーム画面へリダイレクト
    goHome(linkedPatientId);
  };

  const handleProfileAlreadyComplete = async () => {
    // プロフィール登録済みユーザーの招待リンクフロー：即座に家族連携を実行
    const onboardingData = getOnboardingData();
    let linkedPatientId: number | undefined;
    if (onboardingData) {
      try {
        linkedPatientId = await confirmAndLinkFamily(queryClient);
      } catch (err) {
        // 家族連携に失敗してもプロフィール登録は完了済みのためホーム画面へは進める。
        // linkedPatientId が undefined のままなら、ホーム側で既存連携の利用者へ着地する。
        console.error('家族連携に失敗しました:', err);
      }
    }
    goHome(linkedPatientId);
  };

  const handleBack = () => {
    goBack();
  };

  return (
    <UserProfile
      onComplete={handleComplete}
      onProfileAlreadyComplete={handleProfileAlreadyComplete}
      onBack={handleBack}
    />
  );
};

export default UserProfilePage;
